import {DatasetInfo} from "api/model/dataset/DatasetInfo";
import FindAndReplaceDialog
    from "components/dashboard/dataset-window/datasets-menu/find-and-replace-dialog/FindAndReplaceDialog";
import React, {useRef, useState} from "react";
import {Menu} from "primereact/menu";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import CreateDatasetDialog from "./create-dataset-dialog/CreateDatasetDialog";
import ClearDatasetDialog from "./clear-dataset-dialog/ClearDatasetDialog";
import AddDataDialog from "./add-data-dialog/AddDataDialog";
import {ChronoUnitLegacy} from "utils/time-utils";
import EditDatasetDialog from "./edit-dataset-dialog/EditDatasetDialog";
import ManageDatasetMappers from "components/dashboard/dataset-window/datasets-menu/dataset-mappers/ManageDatasetMappers";

interface IDatasetsMenuProps {
    selectedDatasetID: Array<DatasetInfo>,
    setSelectedDatasets: (arr: Array<DatasetInfo>) => void
}


const DatasetsMenu = ({selectedDatasetID, setSelectedDatasets}: IDatasetsMenuProps) => {
    const [createDatasetDialogVisibility, setCreateDialogVisibility] = useState<boolean>(false);
    const [clearDataDialogVisibility, setClearDataDialogVisibility] = useState<boolean>(false);
    const [addDataDialogVisibility, setAddDataDialogVisibility] = useState<boolean>(false);
    const [editDatasetDialogVisibility, setEditDatasetDialogVisibility] = useState<boolean>(false);
    const [findAndReplaceDialogVisibility, setFindAndReplaceDialogVisibility] = useState<boolean>(false);
    const [manageMappersDialogVisibility, setManageMappersDialogVisibility] = useState<boolean>(false)

    const menu = useRef(null);
    const items = [
        {
            label: "Dataset options",
            items: [
                {
                    label: "Create dataset",
                    icon: "pi pi-plus-circle",
                    command: () => {
                        setCreateDialogVisibility(true);
                    }
                },
                {
                    label: "Edit dataset",
                    icon: "pi pi-pencil",
                    command: () => {
                        setEditDatasetDialogVisibility(true);
                    },
                    disabled: selectedDatasetID.length === 0
                },
                {
                    label: "Find & Replace",
                    icon: "pi pi-search",
                    command: () => {
                        setFindAndReplaceDialogVisibility(true);
                    },
                    disabled: selectedDatasetID.length === 0
                }
            ]
        },
        {
            label: "Mappings options",
            items: [
                {
                    label: "Manage mappings",
                    icon: "pi pi-pencil",
                    command: () => {
                        setManageMappersDialogVisibility(true);
                    }
                }
            ]
        },
        {
            label: "Data options",
            items: [
                {
                    label: "Add data",
                    icon: "pi pi-plus",
                    command: () => {
                        setAddDataDialogVisibility(true);
                    },
                    disabled: selectedDatasetID.length !== 1
                },
                {
                    label: "Clear data",
                    icon: "pi pi-info-circle",
                    command: () => {
                        setClearDataDialogVisibility(true);
                    },
                    disabled: selectedDatasetID.length === 0
                }
            ]
        }

    ];

    return (
        <>
            <div>
                <Menu model={items} popup ref={menu} id="popup_menu"/>
                <Button className="p-button-outlined p-button-secondary" icon="pi pi-bars"
                        onClick={(event) => menu.current.toggle(event)} aria-controls="popup_menu" aria-haspopup/>
            </div>
            <Dialog
                style={{width: "min(100vw, 800px)", maxHeight: "600px"}}
                header="Create new dataset"
                visible={createDatasetDialogVisibility}
                onHide={() => setCreateDialogVisibility(false)}
                resizable={true}
                modal={false}
            >
                <CreateDatasetDialog setCreateDialogVisibility={setCreateDialogVisibility}/>
            </Dialog>
            <Dialog
                style={{width: "min(100vw, 1000px)", height: "400x"}}
                header="Edit dataset"
                visible={editDatasetDialogVisibility}
                onHide={() => setEditDatasetDialogVisibility(false)}
                resizable={true}
                modal={false}
            >
                <EditDatasetDialog setEditDatasetDialogVisibility={setEditDatasetDialogVisibility}
                                   selectedDatasetID={selectedDatasetID} setSelectedDatasets={setSelectedDatasets}/>
            </Dialog>
            <Dialog
                style={{width: "min(100vw, 400px)", height: "400x"}}
                header="Edit dataset"
                visible={findAndReplaceDialogVisibility}
                onHide={() => setFindAndReplaceDialogVisibility(false)}
                resizable={true}
            >
                <FindAndReplaceDialog setFindAndReplaceDialogVisibility={setFindAndReplaceDialogVisibility}
                                      selectedDatasetID={selectedDatasetID} setSelectedDatasets={setSelectedDatasets}/>
            </Dialog>
            <Dialog
                style={{width: "min(100vw, 800px)", maxHeight: "600px"}}
                header="Manage Mappers"
                visible={manageMappersDialogVisibility}
                onHide={() => setManageMappersDialogVisibility(false)}
                resizable={true}
            >
                <ManageDatasetMappers />
            </Dialog>
            <Dialog
                style={{width: "min(100vw, 400px)", height: "400x"}}
                header="Clear dataset data"
                visible={clearDataDialogVisibility}
                onHide={() => setClearDataDialogVisibility(false)}
                resizable={false}
                modal
            >
                <ClearDatasetDialog setClearDataDialogVisibility={setClearDataDialogVisibility}
                                    selectedDatasetID={selectedDatasetID}/>
            </Dialog>
            <Dialog onHide={() => setAddDataDialogVisibility(false)}
                    style={{width: "min(100vw, 600px)", height: "400x"}}
                    visible={addDataDialogVisibility}
                    header={"Add data to dataset"}
                    modal={true}
            >
                <AddDataDialog selectedDatasetID={selectedDatasetID}
                               firstLoadDate={new Date()}
                               dateFrequency={ChronoUnitLegacy.MINUTES}
                               closeDialog={() => setAddDataDialogVisibility(false)}
                />
            </Dialog>
        </>
    );
};

export default DatasetsMenu;